module.exports = __webpack_public_path__ + "img/news.eb44ee8f.png";